import type { PayloadAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';
import {
  fetchCommentsFailure,
  fetchCommentsRequest,
  fetchCommentsSuccess,
} from 'actions/envelopeActions';
import type { API, EnvelopeAction, ErrorObject, NormalizedResource } from 'types';

export type EnvelopeActionsState = {
  items: NormalizedResource<EnvelopeAction>;
  count: number;
  loading: string[];
  error: ErrorObject | null;
};

export type EnvelopeActionsReducer<P = void> = (
  state: EnvelopeActionsState,
  payload: PayloadAction<P>
) => EnvelopeActionsState;

const defaultState: EnvelopeActionsState = {
  items: {},
  error: null,
  loading: [],
  count: 0,
};

const handleFetchCommentsRequest: EnvelopeActionsReducer = (state) => ({
  ...state,
  error: null,
  loading: [...state.loading, fetchCommentsRequest.toString()],
});

const handleFetchCommentsSuccess: EnvelopeActionsReducer<API.WrappedAPIResponse<EnvelopeAction>> = (
  state,
  { payload }
) => {
  const comments: NormalizedResource<EnvelopeAction> = {};

  payload.records.forEach((item) => {
    comments[item.uuid] = {
      ...item,
    };
  });

  const newState = {
    ...state,
    items: comments,
    count: payload.count,
    loading: state.loading.filter((s) => s !== fetchCommentsRequest.toString()),
  };

  return newState;
};

const handleFetchCommentsFailure: EnvelopeActionsReducer<ErrorObject> = (state) => ({
  ...state,
  loading: state.loading.filter((s) => s !== fetchCommentsRequest.toString()),
});

const handlers = {
  [fetchCommentsRequest.toString()]: handleFetchCommentsRequest,
  [fetchCommentsSuccess.toString()]: handleFetchCommentsSuccess,
  [fetchCommentsFailure.toString()]: handleFetchCommentsFailure,
};

const envelopeActionsReducer = createReducer(defaultState, handlers);

export default envelopeActionsReducer;
